import { getContext } from '@/context';

type InternalStorageState = {
  shouldSkipAutoGeneration?: Record<string, boolean>;
  [key: string]: unknown;
};

const getShouldSkipAutoGeneration = (jsonUrl: string): boolean => {
  if (!jsonUrl) return false;

  try {
    const state = getContext().internals.getState({
      permanent: true,
    }) as InternalStorageState;
    const skipFlags = state.shouldSkipAutoGeneration || {};
    console.log('[autoGeneration] skipFlags:', skipFlags);

    return skipFlags[jsonUrl] || false;
  } catch {
    return false;
  }
};

const setShouldSkipAutoGeneration = async (jsonUrl: string): Promise<void> => {
  if (!jsonUrl) return;

  try {
    const state = getContext().internals.getState({
      permanent: true,
    }) as InternalStorageState;
    const skipFlags = state.shouldSkipAutoGeneration || {};

    await getContext().internals.setState(
      {
        ...state,
        shouldSkipAutoGeneration: {
          ...skipFlags,
          [jsonUrl]: true,
        },
      },
      { permanent: true }
    );
  } catch {
    // Silent fail - non-critical state persistence
  }
};

export { getShouldSkipAutoGeneration, setShouldSkipAutoGeneration };
